import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

export interface FacultySponsor {
  id: number;
  irbApplicationId: number;
  piEmail: string;
  piFirstname: string;
  piLastName: string;
  sponsorEmail: string;
  sponsorDegree: string;
  fullname: string;
  reseachDescription: string;
  irbTitle: string;
  typeOfReview: string;
  signature: string;
  isApproved: boolean;
  requestedDate: Date;
  decisionDate: Date;
  userRole: string;
}

export interface FacultyResponse {
  status: string;
  message: string;
  data: Array<FacultySponsor>;
}

export interface FacultyInfo {
  facultyRequests: FacultyResponse;
  message: string;
}

@Module
export default class FacultyModule extends VuexModule implements FacultyInfo {
  facultyRequests = {} as FacultyResponse;
  facultyRequestEdit = {} as FacultySponsor;
  message = "";

  get currentFacultyRequests(): FacultyResponse {
    return this.facultyRequests;
  }

  get getFacultyMessage(): string {
    return this.message;
  }

  get currentFacultyRequestEdit(): FacultySponsor {
    return this.facultyRequestEdit;
  }

  @Mutation
  [Mutations.SET_FACULTY_SPONSOR_REQUESTS](facultyRequests) {
    this.facultyRequests = facultyRequests;
  }

  @Mutation
  [Mutations.SET_FACULTY_SPONSOR_REQUEST_EDIT](facultyRequestEdit) {
    this.facultyRequestEdit = facultyRequestEdit;
  }

  @Mutation
  [Mutations.SET_FACULTY_MESSAGE](message) {
    this.message = message;
  }

  @Action
  [Actions.GET_FACULTY_SPONSOR_REQUESTS](info) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.query("irb/faculty/requests", {params: info?.params})
        .then(({ data }) => {
          this.context.commit(Mutations.SET_FACULTY_SPONSOR_REQUESTS, data);
        })
        .catch(() => {
          this.context.commit(Mutations.SET_FACULTY_SPONSOR_REQUESTS, {});
        });
    } else {
      this.context.commit(Mutations.SET_FACULTY_SPONSOR_REQUESTS, {});
    }
  }

  @Action
  [Actions.POST_FACULTY_APPROVAL](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("irb/faculty/approve", data)
          .then(({ data }) => {
            console.log(data);
            this.context.commit(Mutations.SET_FACULTY_MESSAGE, data.message);
            resolve();
          })
          .catch(({ response }) => {
            console.log(response);
            this.context.commit(
              Mutations.SET_FACULTY_MESSAGE,
              response.data.message
            );
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_FACULTY_MESSAGE, "Something wrong");
        reject();
      }
    });
  }
  @Action
  [Actions.POST_FACULTY_APPROVAL_REASIGN](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("irb/faculty/reassign", data)
          .then(({ data }) => {
            console.log(data);
            this.context.commit(Mutations.SET_FACULTY_MESSAGE, data.message);
            resolve();
          })
          .catch(({ response }) => {
            console.log(response);
            this.context.commit(
              Mutations.SET_FACULTY_MESSAGE,
              response.data.message
            );
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_FACULTY_MESSAGE, "Something wrong");
        reject();
      }
    });
  }
}
